import { pluralize } from "@/helpers/pluralize";
import { UnwrapFolderResponse } from "@/api/files";

export const formatUnwrapSummary = ({
  moved_count,
  renamed_count,
  dropped_duplicate_count,
}: UnwrapFolderResponse): string => {
  const parts = [`${pluralize(moved_count, "item", "items")} moved up`];

  if (renamed_count > 0) {
    parts.push(`${pluralize(renamed_count, "item", "items")} renamed to avoid name clashes`);
  }

  if (dropped_duplicate_count > 0) {
    parts.push(`${pluralize(dropped_duplicate_count, "duplicate", "duplicates")} skipped (already in the destination)`);
  }

  return parts.join(", ");
};
